import {defineMessages} from 'react-intl';

export default defineMessages({
	productDescriptionTitle: {
		id: 'productAccordion.title.productDescription',
		defaultMessage: 'DESCRIPTION',
	},
	productDetailsTitle: {
		id: 'productAccordion.title.productDetails',
		defaultMessage: 'PRODUCT DETAIL',
	},
	productMaterialsTitle: {
		id: 'productAccordion.title.productMaterials',
		defaultMessage: 'MATERIALS',
	},
});
